import { render, staticRenderFns } from "./FaqSearch.vue?vue&type=template&id=9fe9946c&scoped=true"
import script from "./FaqSearch.vue?vue&type=script&lang=js"
export * from "./FaqSearch.vue?vue&type=script&lang=js"
import style0 from "./FaqSearch.vue?vue&type=style&index=0&id=9fe9946c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe9946c",
  null
  
)

export default component.exports